module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cm0Hr"))).then(() => parcelRequire('5erN3'));